import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Modal, { ModalHeader, ModalFooter } from 'components/Modal';

import './style.scss';

const DeleteRuleGroupModal = ({
  onCloseRequest,
  onSubmit,
  isFetching,
  name,
}) => (
  <Modal isOpen closeOnEsc onCloseRequest={onCloseRequest}>
    <ModalHeader
      icon={<span className="icon-warning" styleName="icon-warning" />}
      title={
        <span styleName="title">
          <div>Are you sure you want to delete rule group</div>
          <div>&#8220;{name}&#8221; and all of its rules?</div>
        </span>
      }
      subtitle={
        <span>
          <strong>Notice:</strong> Deleting an Rule Group also deletes all rules
          in this group.
        </span>
      }
    />

    <ModalFooter justifyContent="flex-end">
      <Button isLarge isTransparent type="button" onClick={onCloseRequest}>
        Cancel
      </Button>

      <Button
        isLarge
        isWarning
        type="button"
        onClick={onSubmit}
        isLoading={isFetching}
        data-test="submit-button"
      >
        Yes delete it
      </Button>
    </ModalFooter>
  </Modal>
);

DeleteRuleGroupModal.propTypes = {
  isFetching: PropTypes.bool,
  onCloseRequest: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  name: PropTypes.string,
};

DeleteRuleGroupModal.defaultProps = {
  isFetching: false,
  onCloseRequest: () => {},
};

export default DeleteRuleGroupModal;
